export const Testimonials = [
  {
    position: "Figrun Hunter",
    message:
      "Ready to transform your daily routes into routes of discovery? Figrun is your playfield. 🌍",
    user: {
      profilePic: "https://mui.com/static/images/avatar/3.jpg",
      firstName: "RACHEL",
      lastName: "GREEN",
    },
  },
  {
    position: "Urban Explorer",
    message:
      "Every journey feels like an adventure now. Figrun helped me discover hidden gems I’d never notice otherwise. 🚶‍♂️",
    user: {
      profilePic: "https://mui.com/static/images/avatar/4.jpg",
      firstName: "JOEY",
      lastName: "TRIBBIANI",
    },
  },
  {
    position: "Travel Enthusiast",
    message:
      "Figrun completely changed how I see my city. It’s not just travel — it’s an experience every single day. ✨",
    user: {
      profilePic: "https://mui.com/static/images/avatar/5.jpg",
      firstName: "MONICA",
      lastName: "GELLER",
    },
  },
  {
    position: "Adventure Seeker",
    message:
      "From routine commutes to exciting discoveries, Figrun makes every step worth it. Highly addictive in the best way! 🌟",
    user: {
      profilePic: "https://mui.com/static/images/avatar/6.jpg",
      firstName: "CHANDLER",
      lastName: "BING",
    },
  },
];
